import replace from 'lodash/replace';
import upperFirst from 'lodash/upperFirst';

export const getCategoriesFromSlug = (slug = ''): string[] =>
  slug
    .split('/')
    .filter((s) => s !== '')
    .map((s) => replace(s, /-/g, ' '))
    .map((s) => upperFirst(s.toLowerCase()));
